// extracted by mini-css-extract-plugin
export var infoItem = "_uo-2";
export var title = "_uo-0";
export var value = "_uo-1";